import { render, staticRenderFns } from "./HoldingDetails.vue?vue&type=template&id=e0eb6848&scoped=true&"
import script from "./HoldingDetails.vue?vue&type=script&lang=js&"
export * from "./HoldingDetails.vue?vue&type=script&lang=js&"
import style0 from "./HoldingDetails.vue?vue&type=style&index=0&id=e0eb6848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0eb6848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
